export const peripheryAddresses = {
  adaptiveCurveIRMFactory: "0xCB7DF7563F86b1b23DB41fC49055119691b4C80d",
  capRiskStewardFactory: "0x4a5A2F83EE9A3433357f31397fa923C331FDb10b",
  edgeFactory: "0x21A5deac1dC5272d98eBa099774f175374Cd37BE",
  edgeFactoryPerspective: "0x5FB2AE4dA71Ed59BA3fc680BB05802B37d40c763",
  escrowedCollateralPerspective: "0x87357473f92385e6daCeB75E45F90c362156AEC2",
  eulerEarnFactoryPerspective: "0x89aba3111f118D667d22f84F587F8AFa8B0ce49F",
  eulerEarnGovernedPerspective: "0xAC6c7a163bA7FD32630A5C8B64e652B1B35ac0E6",
  eulerEarnPublicAllocator: "0x64df6A6F0743FFbBfF98EA5a690d5732C9BaE71f",
  eulerUngoverned0xPerspective: "0xe6aA4244301085bBe65F1a0f0eDEf92e50FbF6dD",
  eulerUngovernedNzxPerspective: "0x415c1Ef3Bb16bAaefD911F6DA54680D299a8FD8e",
  evkFactoryPerspective: "0xB2c41058f441383EfA8f26F3dcff471205599361",
  externalVaultRegistry: "0x264fF8BC0b816990aCf481be908c114b60df5Ef2",
  feeCollector: "0x0000000000000000000000000000000000000000",
  feeFlowController: "0x2fed03714ff6b27Da94e1778a6F4Fac9b38a5108",
  feeFlowControllerUtil: "0xaE6B9D0f199cd81EeAbf0Cd0403228Ba18368520",
  fixedCyclicalBinaryIRMFactory: "0x67955D12d223DC0EFb9b2A887f2Bd296a6Db1147",
  governedPerspective: "0x8c86880D18a4E157EaDE61BdaA8a38c94C0d2Bd9",
  governorAccessControlEmergencyFactory:
    "0xd3159d6edd291b02fA6bf7c75f76659D633E46bf",
  irmRegistry: "0xEF4C370f84a6e5B375577AF85Dc6A29182e3FF56",
  kinkIRMFactory: "0x20122E0CEf46088cF75D91B20e610F55c3E6d7B2",
  kinkyIRMFactory: "0x615172ef5DE0d90e74C23Fb7275110E87d0351C0",
  oracleAdapterRegistry: "0x0d9f28D020760823bbD6BE474938c7aF54842e4c",
  oracleRouterFactory: "0x2Be6B8ecB0F73e5E8C79fEdEA228C4c48b146858",
  swapVerifier: "0x079aEA65ACa7C201c01d9205Ea1d331b3cAa203a",
  swapper: "0xE512a1015248Af9824970d9E688Ad68f7A7C00f1",
  termsOfUseSigner: "0xE75105f9f6c1331BfC0f0b0d773C5D22a8910D82",
} as const
